import { AttachedFilesState } from "@reducers/types/HRM/attachedFiles-state";
import {
  CREATE_ATTACHED_FILE_INFO,
  GET_ATTACHED_FILES_INFO,
  DELETE_ATTACHED_FILE_INFO,
} from "@actions/HRM/employee/types";
import { AttachedFilesInfoActions } from "@actions/HRM/employee/attachedFiles-actions";

import {
  getInitialState,
  getRequestingState,
  getSuccessState,
  getFailedState,
} from "@utils/store";

const initialState: AttachedFilesState = { ...getInitialState() };

const attachedFilesReducer = (
  state = initialState,
  action: AttachedFilesInfoActions,
) => {
  switch (action.type) {
    //CREATE
    case CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state.data,
          createAttachedFileRequest: true,
          createAttachedFileSuccess: false,
          createAttachedFileFailed: false,
        }),
      };
    }

    case CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_SUCCESS: {
      const { payload } = action as any;

      const currentDocs: any = state ? state : {};
      let updatedAttachmentDoc = currentDocs || {};
      if (!updatedAttachmentDoc.attachmentDocument) {
        updatedAttachmentDoc.attachmentDocument = [];
      }

      if (payload.data.documentType === "attachmentDocument") {
        const indexOfNewAttachmentDoc =
          currentDocs?.attachmentDocument?.findIndex(
            (attachmentDoc: any) => attachmentDoc.id === payload.data.id,
          );

        if (indexOfNewAttachmentDoc === -1) {
          updatedAttachmentDoc.attachmentDocument.push(payload.data);
        } else {
          updatedAttachmentDoc.attachmentDocument[indexOfNewAttachmentDoc] =
            payload.data;
        }
      }

      const updatedDocs = {
        ...currentDocs,
        [payload.data.documentType]:
          payload.data.documentType === "attachmentDocument"
            ? updatedAttachmentDoc.attachmentDocument
            : payload.data,
      };

      return {
        ...getSuccessState({
          data: updatedDocs,
          createAttachedFileRequest: false,
          createAttachedFileSuccess: true,
          createAttachedFileFailed: false,
        }),
      };
    }

    case CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          createAttachedFileRequest: false,
          createAttachedFileSuccess: false,
          createAttachedFileFailed: true,
        }),
      };
    }

    //GET
    case GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_REQUEST: {
      return {
        ...getRequestingState({
          data: null,
          getAttachedFilesRequest: true,
          getAttachedFilesSuccess: false,
          getAttachedFilesFailed: false,
        }),
      };
    }

    case GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          data: payload.data.length
            ? payload.data.reduce((prev: any, item: any) => {
                if (item.documentType === "attachmentDocument") {
                  if (!prev[item.documentType]) {
                    prev[item.documentType] = [];
                  }
                  prev[item.documentType].push(item);
                } else {
                  prev[item.documentType] = item;
                }
                return prev;
              }, {})
            : {},
        }),
        getAttachedFilesRequest: false,
        getAttachedFilesSuccess: true,
        getAttachedFilesFailed: false,
      };
    }

    case GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state.data,
          getAttachedFilesRequest: false,
          getAttachedFilesSuccess: false,
          getAttachedFilesFailed: true,
        }),
      };
    }

    //DELETE
    case DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state.data,
          deleteAttachedFileRequest: true,
          deleteAttachedFileSuccess: false,
          deleteAttachedFileFailed: false,
        }),
      };
    }

    case DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_SUCCESS: {
      const { payload } = action as any;

      return {
        ...getFailedState({
          data: {
            ...state,
            [payload.data.documentType]:
              payload.data.documentType === "attachmentDocument"
                ? (state[payload.data.documentType] || []).filter(
                    (item: any) => item !== payload.data,
                  )
                : null,
          },

          deleteAttachedFileRequest: false,
          deleteAttachedFileSuccess: true,
          deleteAttachedFileFailed: false,
        }),
      };
    }

    case DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          deleteAttachedFileRequest: false,
          deleteAttachedFileSuccess: false,
          deleteAttachedFileFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default attachedFilesReducer;
